import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface StopCodingFilter {
    type: 'all' | 'workcenter' | 'group' | 'machine';
    value?: string; // WorkCenter name, Group (MWC), or MachineId
    displayName?: string;
}

interface StopCodingState {
    filter: StopCodingFilter;
}

const initialState: StopCodingState = {
    filter: {
        type: 'all'
    }
};

const stopCodingSlice = createSlice({
    name: "stopCoding",
    initialState,
    reducers: {
        setFilter: (state, action: PayloadAction<StopCodingFilter>) => {
            state.filter = action.payload;
        },
        clearFilter: (state) => {
            state.filter = { type: 'all' };
        }
    },
});

export const { setFilter, clearFilter } = stopCodingSlice.actions;
export default stopCodingSlice.reducer;
